__turbopack_context__.v({
  "benefit": "WhyChoose-module-scss-module__zDMTNW__benefit",
  "benefits": "WhyChoose-module-scss-module__zDMTNW__benefits",
  "checkIcon": "WhyChoose-module-scss-module__zDMTNW__checkIcon",
  "content": "WhyChoose-module-scss-module__zDMTNW__content",
  "contentInner": "WhyChoose-module-scss-module__zDMTNW__contentInner",
  "heading": "WhyChoose-module-scss-module__zDMTNW__heading",
  "image": "WhyChoose-module-scss-module__zDMTNW__image",
  "media": "WhyChoose-module-scss-module__zDMTNW__media",
  "overlay": "WhyChoose-module-scss-module__zDMTNW__overlay",
  "root": "WhyChoose-module-scss-module__zDMTNW__root",
});
